/* ==========================================================================
   MJ HairSolutions — Luxe Theme
   Interactivity: drawers, AJAX cart, gallery, accordions, reveal
   ========================================================================== */
(function () {
  'use strict';

  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => Array.from((ctx || document).querySelectorAll(sel));
  const money = (cents) => {
    // Format in the storefront language (html lang), not the browser locale,
    // so JS-updated prices match Liquid-rendered ones (€23,99 vs €23.99).
    return (cents / 100).toLocaleString(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
    }).replace(/\u00a0/g, ''); // "€ 11,99" -> "€11,99", gelijk aan Liquid's money-filter
  };

  /* ---------- Off-canvas drawers ---------- */
  const overlay = $('[data-overlay]');
  const focusable = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, summary, [tabindex]:not([tabindex="-1"])';
  let panelOpener = null;
  function openPanel(el) {
    if (!el) return;
    if (!panelOpener) panelOpener = document.activeElement;
    el.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    // Focus moves into the panel (after visibility flips); the search panel focuses its own field.
    setTimeout(() => {
      if (!el.classList.contains('is-open') || el.contains(document.activeElement)) return;
      const first = $('[data-close]', el) || $(focusable, el);
      if (first) first.focus();
    }, 60);
  }
  function closeAllPanels() {
    const open = $$('.is-open[data-panel]');
    open.forEach((p) => p.classList.remove('is-open'));
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (open.length && panelOpener && document.contains(panelOpener)) panelOpener.focus();
    panelOpener = null;
  }
  // Keep Tab inside an open panel.
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab' || e.target.closest('[data-combo]')) return;
    const panel = $('.is-open[data-panel]');
    if (!panel) return;
    const items = $$(focusable, panel).filter((n) => n.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    else if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      e.preventDefault();
      const target = $('[data-panel="' + opener.getAttribute('data-open') + '"]');
      closeAllPanels();
      openPanel(target);
    }
    if (e.target.closest('[data-close]')) {
      e.preventDefault();
      closeAllPanels();
    }
  });
  if (overlay) overlay.addEventListener('click', closeAllPanels);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !e.target.closest('[data-combo]')) closeAllPanels(); });

  /* ---------- Accordions ---------- */
  document.addEventListener('click', (e) => {
    const head = e.target.closest('.accordion__head');
    if (!head) return;
    head.parentElement.classList.toggle('is-open');
  });

  /* ---------- Tabs (product info) ---------- */
  document.querySelectorAll('[data-tabs]').forEach((root) => {
    const tabs = [...root.querySelectorAll('[role="tab"]')];
    const select = (tab) => tabs.forEach((t) => {
      const on = t === tab;
      t.setAttribute('aria-selected', on);
      t.tabIndex = on ? 0 : -1;
      document.getElementById(t.getAttribute('aria-controls')).hidden = !on;
    });
    if (tabs[0]) select(tabs[0]); // without JS every panel stays visible
    root.addEventListener('click', (e) => { const t = e.target.closest('[role="tab"]'); if (t) select(t); });
    root.addEventListener('keydown', (e) => {
      const i = tabs.indexOf(e.target);
      if (i < 0 || !['ArrowLeft', 'ArrowRight'].includes(e.key)) return;
      const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
      select(next); next.focus();
    });
  });

  /* ---------- Product gallery (with variant-based media filtering) ---------- */
  const galleryMain = $('[data-gallery-main]');
  if (galleryMain) {
    const galleryImg = $('img', galleryMain);
    const baseUrl = (u) => (u || '').replace(/^https?:/, '').split('?')[0];
    // Normalise option values: lowercase + strip ALL whitespace so e.g. "268 mL" == "268mL".
    const norm = (s) => (s == null ? '' : String(s)).toLowerCase().replace(/\s+/g, '');

    function setMainImage(src) {
      if (galleryImg && src) {
        galleryImg.src = src;
        // Drop the responsive srcset once JS swaps images, otherwise the browser
        // keeps rendering the old srcset candidate instead of the new src.
        galleryImg.removeAttribute('srcset');
      }
      $$('[data-thumb]').forEach((t) =>
        t.classList.toggle('is-active', baseUrl(t.getAttribute('data-full')) === baseUrl(src)));
      // Keep the active thumb in view in the (mobile) thumb strip; horizontal only, never moves the page.
      const active = $('[data-thumb].is-active');
      const strip = active && active.parentElement;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        const r = active.getBoundingClientRect(), sr = strip.getBoundingClientRect();
        strip.scrollTo({ left: strip.scrollLeft + r.left - sr.left - (sr.width - r.width) / 2, behavior: 'smooth' });
      }
    }

    // Manual thumb click (only fires for visible thumbs).
    $$('[data-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => setMainImage(thumb.getAttribute('data-full')));
    });

    // A thumb is shown when it is tagged "all"/untagged, OR when the selected variant's
    // SKU or ID matches any tagged value. SKU/ID are language-independent, so this keeps
    // working when option values are translated (e.g. Mint -> Minze).
    function thumbMatches(thumb, keySet) {
      if (thumb.hasAttribute('data-variant-all')) return true;
      const raw = thumb.getAttribute('data-variant-tags');
      if (!raw) return true; // untagged -> always visible
      return raw.split('|').map(norm).filter(Boolean).some((v) => keySet.has(v));
    }

    // Filter thumbs by the selected variant, then choose the active main image.
    function filterGallery(detail) {
      const featuredImageSrc = detail.featuredImageSrc || null;
      const thumbs = $$('[data-thumb]');
      if (!thumbs.length) { // single-media product: nothing to filter
        if (featuredImageSrc) setMainImage(featuredImageSrc);
        return;
      }
      // Does this product use the tagging convention at all? If not -> no filtering.
      const usesTagging = thumbs.some(
        (t) => !t.hasAttribute('data-variant-all') && t.getAttribute('data-variant-tags'));
      const keySet = new Set([norm(detail.sku), norm(detail.id)].filter(Boolean));
      let visible = [];
      thumbs.forEach((thumb) => {
        const show = usesTagging ? thumbMatches(thumb, keySet) : true;
        thumb.classList.toggle('hidden', !show);
        if (show) visible.push(thumb);
      });
      if (!visible.length) { // nothing matched -> don't blank the gallery, show everything
        thumbs.forEach((t) => t.classList.remove('hidden'));
        visible = thumbs;
      }

      // Prefer the variant's own featured image when it survived the filter; else first visible.
      let target = visible[0];
      if (featuredImageSrc) {
        const match = visible.find(
          (t) => baseUrl(t.getAttribute('data-full')) === baseUrl(featuredImageSrc));
        if (match) target = match;
      }
      setMainImage(target.getAttribute('data-full'));
    }

    // Swipe on the main image: the photo follows the finger, the neighbour slides in beside it.
    // .pdp__main has touch-action: pan-y, so vertical page scroll stays native.
    if (galleryImg && $$('[data-thumb]').length > 1) {
      const peek = document.createElement('img');
      peek.className = 'pdp__peek';
      peek.alt = '';
      peek.setAttribute('aria-hidden', 'true');
      galleryMain.appendChild(peek);
      const EASE = 'transform .28s cubic-bezier(.2,.7,.3,1)';
      let x0 = 0, y0 = 0, dx = 0, w = 0, axis = null, list = [], idx = 0, busy = false;

      // Loops: past the last photo comes the first, before the first the last.
      const neighbour = (dir) => (list.length > 1 ? list[(idx + dir + list.length) % list.length] : undefined);
      const move = (x, animate) => {
        const t = animate ? EASE : 'none';
        galleryImg.style.transition = peek.style.transition = t;
        galleryImg.style.transform = `translateX(${x}px)`;
        peek.style.transform = `translateX(${x + (x < 0 ? w : -w)}px)`;
      };
      const reset = () => {
        galleryImg.style.transition = peek.style.transition = 'none';
        galleryImg.style.transform = '';
        peek.style.transform = 'translateX(100%)';
      };
      reset();

      galleryMain.addEventListener('touchstart', (e) => {
        if (busy || e.touches.length > 1) return;
        x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; dx = 0; axis = null;
        w = galleryMain.offsetWidth;
        list = $$('[data-thumb]').filter((t) => !t.classList.contains('hidden'));
        idx = Math.max(0, list.findIndex((t) => t.classList.contains('is-active')));
        // Warm the cache so the neighbours are ready before they slide in.
        [-1, 1].forEach((d) => { const n = neighbour(d); if (n) new Image().src = n.getAttribute('data-full'); });
      }, { passive: true });

      galleryMain.addEventListener('touchmove', (e) => {
        if (busy || list.length < 2) return;
        const mx = e.touches[0].clientX - x0, my = e.touches[0].clientY - y0;
        if (!axis) { if (Math.abs(mx) < 6 && Math.abs(my) < 6) return; axis = Math.abs(mx) > Math.abs(my) ? 'x' : 'y'; }
        if (axis !== 'x') return;
        const n = neighbour(mx < 0 ? 1 : -1);
        dx = n ? mx : mx * 0.3; // rubber band when there is only one photo
        if (n && peek.dataset.src !== n.getAttribute('data-full')) {
          peek.dataset.src = n.getAttribute('data-full');
          peek.src = peek.dataset.src;
        }
        if (n) { move(dx, false); return; }
        peek.style.transform = 'translateX(100%)';
        galleryImg.style.transition = 'none';
        galleryImg.style.transform = `translateX(${dx}px)`;
      }, { passive: true });

      const end = () => {
        if (axis !== 'x') return;
        axis = null;
        const dir = dx < 0 ? 1 : -1;
        const n = neighbour(dir);
        if (!n || Math.abs(dx) < w * 0.18) { move(0, true); return; }
        busy = true;
        move(-dir * w, true);
        // Timer, not transitionend: that event never fires when the transition is skipped.
        setTimeout(() => {
          setMainImage(n.getAttribute('data-full')); // same URL as peek, so already cached
          reset();
          busy = false;
        }, 290);
      };
      galleryMain.addEventListener('touchend', end);
      galleryMain.addEventListener('touchcancel', end);
    }

    // Driven by the variant selector (see below). Also runs once on init via the
    // selector's initial dispatch, so the first paint matches the default variant.
    document.addEventListener('variant:change', (e) => {
      filterGallery(e.detail || {});
    });
  }

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const wrap = btn.closest('.qty');
    const input = $('input', wrap);
    const dir = parseInt(btn.getAttribute('data-qty-change'), 10);
    // Cart lines may step down to 0 (removes the line); other steppers stop at 1.
    const min = input.hasAttribute('data-line-qty') ? 0 : 1;
    let val = Math.max(min, (parseInt(input.value, 10) || 1) + dir);
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- AJAX cart ---------- */
  // Express checkout buttons (Apple Pay, Shop Pay, ...) in the cart: Shopify only initialises
  // them on load, so re-run it after the cart HTML is swapped.
  window.MJ = window.MJ || {};
  window.MJ.initExpress = function () {
    try {
      const S = window.Shopify;
      if (S && S.StorefrontExpressButtons) S.StorefrontExpressButtons.initialize();
      if (S && S.PaymentButton) S.PaymentButton.init();
    } catch (err) { /* buttons are optional */ }
  };
  async function refreshCart() {
    // The cart page has no [data-cart-contents] of its own (that hook lives on the
    // drawer), so there is nothing to swap in — reload instead.
    if (document.body.classList.contains('template-cart')) { location.reload(); return; }
    try {
      const res = await fetch(window.routes.cart_url + '?section_id=cart-drawer');
      const text = await res.text();
      const html = new DOMParser().parseFromString(text, 'text/html');
      const fresh = html.querySelector('[data-cart-contents]');
      const current = $('[data-cart-contents]');
      if (fresh && current) {
        // Keep focus in the drawer when the focused control is replaced.
        const hadFocus = current.contains(document.activeElement);
        current.innerHTML = fresh.innerHTML;
        window.MJ.initExpress();
        loadUpsell();
        if (hadFocus && !current.contains(document.activeElement)) {
          const f = $('[data-close]', current);
          if (f) f.focus();
        }
      }
      // bubble count
      const cartRes = await fetch(window.routes.cart_url + '.js');
      const cart = await cartRes.json();
      updateCount(cart.item_count);
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
    } catch (err) { console.error('cart refresh failed', err); }
  }

  /* "Anderen kochten ook": swap the bestseller fallback for Shopify recommendations
     based on the first cart product (sections/cart-upsell.liquid). Cached per product. */
  const upsellCache = {};
  async function loadUpsell() {
    const box = $('[data-cart-upsell]');
    if (!box) return;
    const id = box.getAttribute('data-cart-upsell');
    const apply = (html) => { if (html) box.innerHTML = html; };
    if (id in upsellCache) { apply(upsellCache[id]); return; }
    try {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const res = await fetch(root + 'recommendations/products?section_id=cart-upsell&intent=related&limit=10&product_id=' + encodeURIComponent(id));
      if (!res.ok) throw new Error('recommendations failed');
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('.upsell');
      upsellCache[id] = fresh ? fresh.innerHTML : '';
      const live = $('[data-cart-upsell="' + id + '"]');
      if (live && upsellCache[id]) live.innerHTML = upsellCache[id];
    } catch (err) { upsellCache[id] = ''; }
  }
  loadUpsell();
  document.addEventListener('cart:contents', loadUpsell);

  function updateCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  // Adding no longer opens the drawer; the header count pulses and a small
  // "added" toast drops out of the cart button for a few seconds.
  let toastTimer = null;
  function bumpCount(added) {
    document.dispatchEvent(new CustomEvent('cart:added', { detail: added })); // combikorting-popup, zie onderaan dit blok
    $$('[data-cart-count]').forEach((el) => {
      el.classList.remove('is-bump');
      void el.offsetWidth; // restart the animation
      el.classList.add('is-bump');
    });
    const toast = $('[data-cart-toast]');
    if (!toast) return;
    const item = added && added.items ? added.items[0] : added;
    const text = $('[data-cart-toast-text]', toast);
    if (text) text.textContent = (item && item.product_title) || '';
    const img = $('[data-cart-toast-img]', toast);
    if (img) {
      const src = item && item.image;
      img.hidden = !src;
      if (src) img.src = src.replace(/(\.[a-z]+)(\?|$)/i, '_128x128$1$2');
    }
    toast.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { toast.hidden = true; }, 4000);
  }
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-toast] [data-open]')) { const t = $('[data-cart-toast]'); if (t) t.hidden = true; }
  });

  async function addToCart(form, button) {
    const formData = new FormData(form);
    const original = button ? button.textContent : '';
    if (button) { button.disabled = true; button.textContent = '…'; }
    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { Accept: 'application/javascript' },
        body: formData
      });
      if (!res.ok) throw new Error('add failed');
      const added = await res.json().catch(() => null);
      await refreshCart();
      bumpCount(added);
    } catch (err) {
      alert(window.cartStrings.error);
    } finally {
      if (button) { button.disabled = false; button.textContent = original; }
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form) return;
    // The dynamic checkout button ("Buy it now") submits the form natively, straight to checkout.
    if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[type="submit"]'));
  });

  // Quick-add buttons on cards
  document.addEventListener('click', async (e) => {
    const quick = e.target.closest('[data-quick-add]');
    if (!quick) return;
    e.preventDefault();
    const id = quick.getAttribute('data-quick-add');
    // innerHTML, not textContent: the button holds an icon + label.
    const original = quick.innerHTML;
    quick.disabled = true; quick.textContent = '…';
    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      const added = await res.json().catch(() => null);
      await refreshCart();
      bumpCount(added);
    } catch (err) {
      alert(window.cartStrings.error);
    } finally {
      quick.disabled = false; quick.innerHTML = original;
    }
  });

  /* ---------- Combikorting-popup ----------
     Na elke toevoeging (event 'cart:added', ook vanuit de stijlquiz): shampoo zonder conditioner van
     dezelfde maatgroep (of andersom) in de cart, dan biedt de popup de partner met dezelfde geur aan.
     Shopify rekent de korting zelf; deze bedragen (centen) spiegelen alleen de automatische kortingen daar. */
  const COMBO_SAVING = { s: 199, l: 399 }; // klein+klein, 1L+1L
  const comboScent = (t) => t.split(' / ')[0].trim();
  const comboSize = (t) => (/^1\s*l$/i.test((t.split(' / ')[1] || '').trim()) ? 'l' : 's'); // 250/268 mL = klein
  const comboKey = (id) => 'mj-combo-declined-' + id;
  const comboDeclined = (id) => { try { return !!sessionStorage.getItem(comboKey(id)); } catch (e) { return false; } };

  document.addEventListener('cart:added', async (e) => {
    const dlg = $('[data-combo]');
    const raw = $('[data-combo-data]');
    if (!dlg || !raw || dlg.open) return;
    try {
      const d = JSON.parse(raw.textContent);
      const a = e.detail;
      const ids = ((a && a.items) || (a ? [a] : [])).map((i) => i.variant_id || i.id);
      const cart = await (await fetch(window.routes.cart_url + '.js')).json();
      const inCart = cart.items.map((i) => i.variant_id);
      for (const id of ids) {
        const role = ['shampoo', 'conditioner'].find((r) => d[r].some((v) => v.id === id));
        if (!role) continue;
        const other = role === 'shampoo' ? 'conditioner' : 'shampoo';
        const v = d[role].find((x) => x.id === id);
        const size = comboSize(v.title);
        if (d[other].some((p) => inCart.includes(p.id) && comboSize(p.title) === size)) continue;
        const partner = d[other].find((p) => p.available && comboSize(p.title) === size && comboScent(p.title) === comboScent(v.title));
        if (!partner || comboDeclined(partner.id)) continue;
        const saving = COMBO_SAVING[size];
        dlg.dataset.partner = partner.id;
        $('[data-combo-title]', dlg).textContent = d.strings['title_' + other];
        $('[data-combo-name]', dlg).textContent = partner.title.replace(' / ', ' \u00b7 ').replace('mL', ' ml');
        $('[data-combo-line]', dlg).textContent = d.strings.line
          .replace('[total]', window.MJ.money(v.price + partner.price - saving))
          .replace('[saving]', window.MJ.money(saving));
        const img = $('[data-combo-img]', dlg);
        img.hidden = !partner.image;
        if (partner.image) img.src = partner.image;
        $('[data-combo-add]', dlg).disabled = false;
        const toast = $('[data-cart-toast]');
        if (toast) toast.hidden = true; // popup vervangt de toast
        dlg.returnValue = '';
        dlg.showModal();
        return;
      }
    } catch (err) { console.error('combo offer failed', err); }
  });

  document.addEventListener('click', async (e) => {
    const dlg = $('[data-combo]');
    if (!dlg || !dlg.open) return;
    if (e.target === dlg || e.target.closest('[data-combo-decline]')) { dlg.close(); return; } // klik op backdrop = weigeren
    const add = e.target.closest('[data-combo-add]');
    if (!add) return;
    add.disabled = true;
    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ items: [{ id: Number(dlg.dataset.partner), quantity: 1 }] })
      });
      if (!res.ok) throw new Error('add failed');
      await refreshCart();
      dlg.close('added');
    } catch (err) {
      alert(window.cartStrings.error);
      add.disabled = false;
    }
  });
  // Esc, backdrop en "Nee, bedankt" sluiten zonder returnValue 'added': dat telt als weigeren.
  document.addEventListener('close', (e) => {
    if (!e.target.matches || !e.target.matches('[data-combo]') || e.target.returnValue === 'added') return;
    try { sessionStorage.setItem(comboKey(e.target.dataset.partner), '1'); } catch (err) { /* sessionStorage kan ontbreken */ }
  }, true);

  /* ---------- Black Friday-inschrijving (snippets/bf-signup.liquid, bf-hero-signup.liquid) ----------
     Tab opent de dialog (zelfde open/sluit-patroon als de combikorting-popup). Na inschrijven
     (event 'newsletter:ok' van het newsletter-blok hieronder) verdwijnt de tab meteen en bij een
     volgend bezoek ook het blok onder de hero; de bedankmelding blijft in de huidige weergave staan. */
  try { if (localStorage.getItem('mj-bf-signup')) $$('.bf-tab, .bf-hero-signup').forEach((el) => { el.hidden = true; }); } catch (err) { /* localStorage kan ontbreken */ }
  document.addEventListener('newsletter:ok', (e) => {
    if (!e.target.closest('[data-bf-signup]')) return;
    const tab = $('.bf-tab');
    if (tab) tab.hidden = true;
    try { localStorage.setItem('mj-bf-signup', '1'); } catch (err) { /* localStorage kan ontbreken */ }
  });
  const bfDlg = $('[data-bf-dialog]');
  if (bfDlg) {
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-bf-open]')) bfDlg.showModal();
      else if (e.target === bfDlg || e.target.closest('[data-bf-close]')) bfDlg.close(); // klik op backdrop = sluiten
    });
  }

  // Cart line quantity changes & removal (event delegation, debounced)
  let changeTimer;
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;
    clearTimeout(changeTimer);
    changeTimer = setTimeout(() => changeLine(input.getAttribute('data-line-key'), input.value), 250);
  });
  document.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-line-remove]');
    if (!remove) return;
    e.preventDefault();
    changeLine(remove.getAttribute('data-line-key'), 0);
  });

  async function changeLine(key, quantity) {
    try {
      const res = await fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({ id: key, quantity: Number(quantity) })
      });
      if (!res.ok) throw new Error('change failed');
      await refreshCart();
    } catch (err) { console.error(err); }
  }

  /* ---------- PDP: once the variant is in the cart, the add button becomes − n + ---------- */
  const pdpActions = $('.product__actions');
  const pdpForm = pdpActions && pdpActions.closest('[data-product-form]');
  if (pdpForm) {
    const idInput = $('[data-variant-id]', pdpForm);
    const steppers = $$('[data-cart-stepper]');
    const addBtns = [$('[type="submit"]', pdpForm), $('[data-sticky-submit]')].filter(Boolean);
    let items = [];
    let pending = null; // quantity shown while taps are still being collected
    let stepTimer;
    // Automatic discounts can split one variant over several cart lines, so always work with the sum.
    const lines = () => items.filter((i) => idInput && String(i.variant_id) === idInput.value);
    const inCart = () => lines().reduce((n, l) => n + l.quantity, 0);

    // Sets the variant's total: earlier lines keep what they have (up to the target), the last line takes the rest.
    async function setQty(target) {
      const ls = lines();
      const updates = {};
      let rest = target;
      ls.forEach((l, i) => {
        const q = i === ls.length - 1 ? rest : Math.min(l.quantity, rest);
        updates[l.key] = q;
        rest -= q;
      });
      try {
        const res = await fetch(window.routes.cart_update_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
        if (!res.ok) throw new Error('update failed');
      } catch (err) { console.error(err); }
      await refreshCart();
    }

    const render = () => {
      const qty = pending !== null ? pending : inCart();
      steppers.forEach((s) => {
        s.hidden = qty < 1;
        $('[data-step-qty]', s).textContent = qty;
      });
      addBtns.forEach((b) => { b.hidden = qty > 0; });
    };

    document.addEventListener('cart:updated', (e) => { items = e.detail.items || []; render(); });
    document.addEventListener('variant:change', () => { pending = null; clearTimeout(stepTimer); render(); });

    // Taps update the number at once; the cart is changed once the tapping stops.
    steppers.forEach((s) => s.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-step]');
      if (!btn || !lines().length) return;
      pending = Math.max(0, (pending !== null ? pending : inCart()) + Number(btn.getAttribute('data-step')));
      render();
      clearTimeout(stepTimer);
      stepTimer = setTimeout(async () => {
        await setQty(pending);
        pending = null;
        render(); // falls back to the real cart quantity if the change was refused (e.g. stock)
      }, pending === 0 ? 0 : 350); // removing goes at once, so a fresh add can't race it
    }));

    fetch(window.routes.cart_url + '.js')
      .then((r) => r.json())
      .then((cart) => { items = cart.items || []; render(); })
      .catch(() => {});
  }

  /* ---------- Variant selection (product page) ---------- */
  $$('[data-variant-selector]').forEach((selector) => {
    const form = selector.closest('form') || document;
    const idInput = $('[data-variant-id]', form);
    const priceEl = $('[data-product-price]');
    const submitBtn = form.querySelector('[type="submit"]');
    const jsonEl = selector.querySelector('[data-variant-json]');
    const variants = JSON.parse((jsonEl && jsonEl.textContent) || '[]');
    // Shop-wide promotion (theme setting promo_pct): show the discounted price as the
    // sale price, the regular (or compare-at) price struck through. Stacks on a compare-at markdown.
    const promoPct = priceEl ? parseInt(priceEl.getAttribute('data-promo-pct') || '0', 10) : 0;
    if (promoPct > 0) variants.forEach((v) => {
      if (!(v.compare_at_price > v.price)) v.compare_at_price = v.price;
      v.price = Math.round(v.price * (100 - promoPct) / 100);
    });
    const addLabel = submitBtn ? (submitBtn.getAttribute('data-add-label') || submitBtn.textContent.trim()) : '';
    const chooseLabel = submitBtn ? (submitBtn.getAttribute('data-choose-label') || '') : '';
    const priceFrom = priceEl ? (priceEl.getAttribute('data-price-from') || '') : '';
    const soldLabel = submitBtn ? (submitBtn.getAttribute('data-sold-label') || 'Sold out') : '';
    const positions = Array.from(new Set($$('.variant-option', selector).map((o) => o.getAttribute('data-position'))));
    const selected = {};

    // seed from the server-rendered pre-selected options
    $$('.variant-option.is-selected', selector).forEach((opt) => {
      selected[opt.getAttribute('data-position')] = opt.getAttribute('data-value');
    });

    // Given EARLIER option choices, does a matching variant exist (and optionally: is it in stock)?
    function matches(position, value, requireAvailable) {
      const pos = Number(position);
      return variants.some((v) => {
        if (v.options[pos - 1] !== value) return false;
        for (const p of positions) {
          const pp = Number(p);
          if (pp >= pos) continue;
          if (selected[p] != null && v.options[pp - 1] !== selected[p]) return false;
        }
        return requireAvailable ? v.available : true;
      });
    }

    function currentVariant() {
      return variants.find((v) => positions.every((p) => v.options[Number(p) - 1] === selected[p]));
    }

    function refresh() {
      // Option 1 first; every later option stays locked until the ones before it are chosen.
      // With the earlier choices: values without any variant are hidden, sold-out ones greyed.
      let locked = false;
      positions.forEach((position) => {
        const buttons = $$('.variant-option[data-position="' + position + '"]', selector);
        if (selected[position] != null && !matches(position, selected[position], true)) selected[position] = undefined;
        buttons.forEach((btn) => {
          const val = btn.getAttribute('data-value');
          const available = matches(position, val, true);
          btn.hidden = !locked && !matches(position, val, false);
          btn.classList.toggle('is-locked', locked);
          btn.classList.toggle('is-unavailable', !locked && !available);
          btn.setAttribute('aria-disabled', locked || !available ? 'true' : 'false');
          btn.classList.toggle('is-selected', !locked && val === selected[position]);
        });
        const label = $('[data-option-selected="' + position + '"]');
        if (label) label.textContent = (!locked && selected[position]) || '';
        const hint = $('[data-option-hint="' + position + '"]');
        if (hint) hint.hidden = !locked;
        if (locked || selected[position] == null) locked = true;
      });

      const match = currentVariant();
      if (idInput) {
        idInput.value = match ? match.id : '';
        idInput.dispatchEvent(new Event('change', { bubbles: true })); // the dynamic checkout button follows the variant
      }
      if (priceEl) priceEl.textContent = match ? money(match.price) : priceFrom;

      // Sale display: compare-at price + discount % badge
      const compareEl = $('[data-product-compare]');
      const discountEl = $('[data-discount-badge]');
      if (!match) {
        if (compareEl) compareEl.hidden = true;
        if (discountEl) discountEl.hidden = true;
        if (priceEl) priceEl.classList.remove('is-sale');
      }
      if (match) {
        const onSale = match.compare_at_price && match.compare_at_price > match.price;
        if (compareEl) {
          compareEl.hidden = !onSale;
          compareEl.textContent = onSale ? money(match.compare_at_price) : '';
        }
        if (discountEl) {
          discountEl.hidden = !onSale;
          discountEl.textContent = onSale
            ? '−' + Math.round((1 - match.price / match.compare_at_price) * 100) + '%'
            : '';
        }
        if (priceEl) priceEl.classList.toggle('is-sale', !!onSale);
      }

      // Stock / delivery promise line
      const stockEl = $('[data-availability]');
      if (stockEl) stockEl.hidden = !match;
      if (stockEl && match) {
        const ok = match.available;
        stockEl.classList.toggle('product__stock--out', !ok);
        const textEl = $('[data-availability-text]', stockEl);
        if (textEl) textEl.textContent = stockEl.getAttribute(ok ? 'data-text-available' : 'data-text-unavailable');
      }

      // Tell the gallery which variant is active so it can filter media (alt-text tags)
      // and pick the main image. Pass the variant's own featured image as a preference.
      const values = positions.map((p) => selected[p]).filter((v) => v != null);
      let featuredImageSrc = null;
      if (match && match.featured_image && match.featured_image.src) {
        featuredImageSrc = match.featured_image.src;
        if (featuredImageSrc.indexOf('//') === 0) featuredImageSrc = 'https:' + featuredImageSrc;
      }
      if (submitBtn) {
        const ok = !!(match && match.available);
        submitBtn.disabled = !ok;
        submitBtn.textContent = ok ? addLabel : (match ? soldLabel : chooseLabel);
      }
      // Dispatch AFTER the submit button update so listeners (sticky bar) see fresh state.
      document.dispatchEvent(new CustomEvent('variant:change', {
        detail: {
          values: values,
          sku: match ? match.sku : null,
          id: match ? match.id : null,
          featuredImageSrc: featuredImageSrc,
          variant: match || null
        }
      }));
    }

    $$('.variant-option', selector).forEach((opt) => {
      opt.addEventListener('click', () => {
        if (opt.hidden || opt.classList.contains('is-locked') || opt.classList.contains('is-unavailable')) return;
        const pos = Number(opt.getAttribute('data-position'));
        selected[pos] = opt.getAttribute('data-value');
        // Picking a value (e.g. a scent) selects the first in-stock value of every later option,
        // in button order: volumes are rendered low -> high, so that is the smallest volume.
        positions.forEach((p) => {
          if (Number(p) <= pos) return;
          selected[p] = undefined;
          const first = $$('.variant-option[data-position="' + p + '"]', selector).find((b) => matches(p, b.getAttribute('data-value'), true));
          if (first) selected[p] = first.getAttribute('data-value');
        });
        refresh();
      });
    });

    refresh();
  });

  /* ---------- Sticky add-to-cart bar (mobile) ---------- */
  const stickyBar = $('[data-sticky-atc]');
  if (stickyBar) {
    const productForm = $('[data-product-form]');
    const mainSubmit = productForm ? productForm.querySelector('[type="submit"]') : null;
    const stickyBtn = $('[data-sticky-submit]', stickyBar);
    const stickyPrice = $('[data-sticky-price]', stickyBar);
    const anchor = $('.product__actions');

    // Shown only between "buy button scrolled up out of view" and "footer in view". The bar is fixed,
    // so toggling it never moves the observed elements: no feedback loop, no flicker at the edge.
    let pastButton = false;
    let atFooter = false;
    const setVisible = () => {
      const on = pastButton && !atFooter;
      stickyBar.classList.toggle('is-visible', on);
      stickyBar.setAttribute('aria-hidden', on ? 'false' : 'true');
      stickyBar.inert = !on; // hidden bar: not clickable, not focusable
    };
    setVisible();
    if (anchor && 'IntersectionObserver' in window) {
      // The huge bottom margin makes "intersecting" mean "not yet scrolled up past the top edge", so the state
      // hangs on one edge only. Otherwise a jump from the footer to the top (button below the fold both times)
      // would never cross a threshold and the bar would stay up.
      new IntersectionObserver(([entry]) => {
        pastButton = !entry.isIntersecting;
        setVisible();
      }, { rootMargin: '0px 0px 100000px 0px' }).observe(anchor);
      const footer = $('.ftr');
      if (footer) {
        new IntersectionObserver(([entry]) => { atFooter = entry.isIntersecting; setVisible(); }).observe(footer);
      }
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        if (!productForm || !mainSubmit || mainSubmit.disabled) return;
        productForm.requestSubmit(mainSubmit);
      });
    }

    // Keep price + button state in sync with the selected variant.
    document.addEventListener('variant:change', (e) => {
      const v = (e.detail || {}).variant;
      if (stickyPrice) stickyPrice.textContent = v ? money(v.price) : (stickyPrice.getAttribute('data-price-from') || stickyPrice.textContent);
      if (stickyBtn && mainSubmit) {
        stickyBtn.disabled = mainSubmit.disabled;
        stickyBtn.textContent = mainSubmit.textContent;
      }
    });
  }

  /* ---------- Product-type filter (client-side) ---------- */
  const normType = (s) => (s || '').trim().toLowerCase();
  $$('[data-type-filter]').forEach((typeFilter) => {
    // Scope to this filter's own grid (a page can hold several, e.g. assortment + collection).
    const scope = typeFilter.closest('.assortment') || document;
    const grid = $('.product-grid', scope);
    if (!grid) return;
    const cards = $$('.card', grid);
    const countEl = $('[data-product-count]', scope);
    function updateCount(n) {
      if (!countEl) return;
      const tpl = countEl.getAttribute('data-count-' + (n === 1 ? 'one' : 'other'));
      countEl.textContent = tpl ? tpl.replace('%n', n) : String(n);
    }

    function applyType(type) {
      let shown = 0;
      cards.forEach((card) => {
        const show = type === '*' || (type === 'sale' ? card.hasAttribute('data-on-sale') : normType(card.getAttribute('data-product-type')) === normType(type));
        card.classList.toggle('hidden', !show);
        if (show && !card.hasAttribute('data-bundle')) shown++;
      });
      $$('[data-type-filter-btn]', typeFilter).forEach((b) => {
        const on = b.getAttribute('data-type-filter-btn') === type;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      updateCount(shown);
    }
    applyType('*');

    typeFilter.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-type-filter-btn]');
      if (btn) applyType(btn.getAttribute('data-type-filter-btn'));
    });
  });

  /* ---------- Newsletter ----------
     Schrijft direct in op de Klaviyo-lijst, zonder herladen. Lukt dat niet (adblocker,
     storing), dan gaat het formulier alsnog gewoon naar Shopify. */
  $$('[data-newsletter]').forEach((form) => {
    const holder = form.closest('[data-klaviyo-list]');
    if (!holder) return;
    // Meerdere lijsten: komma-gescheiden id's (bijv. de Black Friday-formulieren).
    const lists = (holder.getAttribute('data-klaviyo-list') || '').split(',').map((l) => l.trim()).filter(Boolean);
    const company = holder.getAttribute('data-klaviyo-company');
    if (!lists.length || !company) return;
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const email = form.querySelector('[name="contact[email]"]').value.trim();
      button.disabled = true;
      Promise.all(lists.map((list) => fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + company, {
        method: 'POST',
        headers: { 'content-type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Website nieuwsbrief',
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: list } } }
          }
        })
      }))).then((responses) => {
        if (!responses.every((res) => res.ok)) throw new Error('subscribe failed');
        form.querySelector('.nl__form').hidden = true;
        const note = form.querySelector('[data-newsletter-success]');
        note.hidden = false;
        note.focus();
        form.dispatchEvent(new CustomEvent('newsletter:ok', { bubbles: true }));
      }).catch(() => form.submit());
    });
  });
  // Na de Shopify-fallback: parameters uit de adresbalk halen.
  if (/[?&](customer_posted|contact_posted|form_type)=/.test(location.search)) {
    history.replaceState(null, '', location.pathname);
  }

})();

/* ==========================================================================
   Redesign additions — each block is self-contained and only ADDS behaviour.
   Hooks: [data-slider], [data-rail], [data-quick-pick], [data-discount-form],
   [data-search-input], [data-mega-toggle], [data-product-save]
   ========================================================================== */

/* ---------- Shared (local copies; the block above keeps its own privates) ---------- */
(function () {
  'use strict';
  window.MJ = window.MJ || {};
  window.MJ.money = function (cents) {
    return (cents / 100).toLocaleString(document.documentElement.lang || undefined, {
      style: 'currency',
      currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
    }).replace(/\u00a0/g, ''); // "€ 11,99" -> "€11,99", gelijk aan Liquid's money-filter
  };
  window.MJ.reduceMotion = function () {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };
})();

/* ---------- Hero slider ----------
   Slides liggen gestapeld (CSS in sections/hero.liquid): .is-active fadet in bovenop .is-leaving.
   Autoplay loopt door bij hover en focus; alleen een verborgen tabblad pauzeert. Swipe op touch. */
(function () {
  'use strict';
  Array.prototype.forEach.call(document.querySelectorAll('[data-slider]'), function (root) {
    const track = root.querySelector('[data-slider-track]');
    if (!track) return;
    const slides = Array.from(track.querySelectorAll('[data-slide]'));
    const nav = root.querySelectorAll('[data-slider-prev],[data-slider-next],[data-slider-tab]');

    if (slides.length < 2) {                       // single slide: no controls
      Array.prototype.forEach.call(nav, function (el) { el.hidden = true; });
      if (slides[0]) slides[0].classList.add('is-active');
      return;
    }

    const delay = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    const reduce = window.MJ.reduceMotion();
    let index = Math.max(0, slides.findIndex(function (s) { return s.classList.contains('is-active'); }));
    let timer = null;
    let leaveTimer = null;
    let inView = true;

    // Black Friday-inschrijving in een slide: autoplay staat stil zolang de focus in het formulier zit of het
    // veld tekst bevat, en stopt definitief na een geslaagde inschrijving (de bedankmelding blijft staan).
    const signup = root.querySelector('.bf-hero-signup');
    const signupField = signup && signup.querySelector('input[type="email"]');
    let signedUp = false;
    function held() {
      return signedUp || !!(signup && (signup.contains(document.activeElement) || (signupField && signupField.value)));
    }

    function paint() {
      const running = delay && !reduce && !document.hidden && inView && !held();
      Array.prototype.forEach.call(root.querySelectorAll('[data-slider-tab]'), function (tab) {
        const on = (parseInt(tab.getAttribute('data-slider-tab'), 10) || 0) === index;
        tab.classList.toggle('is-active', on);
        const bar = tab.querySelector('[data-slider-progress]');
        if (!bar) return;
        bar.style.transition = 'none';
        bar.style.transform = on && !running ? 'scaleX(1)' : 'scaleX(0)';
        if (on && running) {
          void bar.offsetWidth;                    // restart the transition
          bar.style.transition = 'transform ' + delay + 'ms linear';
          bar.style.transform = 'scaleX(1)';
        }
      });
    }

    function go(n) {
      const next = (n + slides.length) % slides.length;
      if (next === index) { paint(); return; }
      clearTimeout(leaveTimer);
      slides.forEach(function (s) { s.classList.remove('is-leaving'); });
      const leaving = slides[index];
      leaving.classList.remove('is-active');
      leaving.classList.add('is-leaving');
      index = next;
      slides[index].classList.add('is-active');
      leaveTimer = setTimeout(function () { leaving.classList.remove('is-leaving'); }, reduce ? 0 : 1100);
      paint();
    }

    function play() {
      stop();
      if (!delay || reduce || document.hidden || !inView || held()) return;
      timer = setInterval(function () { go(index + 1); }, delay);
    }
    function stop() { if (timer) clearInterval(timer); timer = null; }

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-slider-prev]')) { go(index - 1); play(); return; }
      if (e.target.closest('[data-slider-next]')) { go(index + 1); play(); return; }
      const tab = e.target.closest('[data-slider-tab]');
      if (tab) { go(parseInt(tab.getAttribute('data-slider-tab'), 10) || 0); play(); }
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { go(index - 1); play(); }
      if (e.key === 'ArrowRight') { go(index + 1); play(); }
    });

    // Swipe: stacked slides don't scroll, so read the gesture ourselves (passive: page scroll stays native).
    let x0 = null;
    let y0 = null;
    root.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX;
      y0 = e.touches[0].clientY;
    }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      const dx = e.changedTouches[0].clientX - x0;
      const dy = e.changedTouches[0].clientY - y0;
      x0 = y0 = null;
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
      go(dx < 0 ? index + 1 : index - 1);
      play();
    }, { passive: true });

    document.addEventListener('visibilitychange', function () { play(); paint(); });

    if (signup) {
      ['focusin', 'focusout', 'input'].forEach(function (type) {
        signup.addEventListener(type, function () { play(); paint(); });
      });
      root.addEventListener('newsletter:ok', function (e) {
        if (!e.target.closest('.bf-hero-signup')) return;
        signedUp = true; stop(); paint();
      });
    }

    // Scrolled past: stop the timer and freeze the animations, so scrolling has nothing else to render.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        inView = entries[0].isIntersecting;
        root.classList.toggle('is-offscreen', !inView);
        play(); paint();
      }).observe(root);
    }

    paint();
    play();
  });
})();

/* ---------- Rail carousel arrows ---------- */
(function () {
  'use strict';
  Array.prototype.forEach.call(document.querySelectorAll('[data-rail]'), function (rail) {
    const scope = rail.closest('.shopify-section') || document;
    const prev = scope.querySelector('[data-rail-prev]');
    const next = scope.querySelector('[data-rail-next]');
    if (!prev && !next) return;

    function step() {
      const first = rail.firstElementChild;
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      return first ? first.getBoundingClientRect().width + gap : rail.clientWidth * 0.8;
    }
    function sync() {
      const max = rail.scrollWidth - rail.clientWidth - 2;
      const atStart = rail.scrollLeft <= 2;
      const atEnd = rail.scrollLeft >= max;
      const none = max <= 0;
      if (prev) { prev.disabled = atStart || none; prev.classList.toggle('is-disabled', atStart || none); }
      if (next) { next.disabled = atEnd || none; next.classList.toggle('is-disabled', atEnd || none); }
    }
    function scrollBy(dir) {
      rail.scrollBy({ left: dir * step(), behavior: window.MJ.reduceMotion() ? 'auto' : 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollBy(-1); });
    if (next) next.addEventListener('click', function () { scrollBy(1); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });
})();

/* ---------- Quick add: variant popover ---------- */
(function () {
  'use strict';
  function closeAll(except) {
    Array.prototype.forEach.call(document.querySelectorAll('[data-quick-popover]'), function (pop) {
      if (pop !== except) pop.hidden = true;
    });
    // The "Kies variant" button sits below the card now: keep its aria-expanded in step.
    Array.prototype.forEach.call(document.querySelectorAll('[data-quick-pick][aria-expanded="true"]'), function (btn) {
      const card = btn.closest('.card');
      if (!except || !card || !card.contains(except)) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-quick-pick]');
    if (trigger) {
      e.preventDefault();
      const scope = trigger.closest('.card') || trigger.parentElement;
      const pop = scope && scope.querySelector('[data-quick-popover]');
      if (!pop) return;
      const open = !pop.hidden;
      closeAll(pop);
      pop.hidden = open;
      trigger.setAttribute('aria-expanded', String(!open));
      return;
    }
    if (!e.target.closest('[data-quick-popover]')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll(null);
  });

  // One pill row per option; the hidden id follows the picked combination.
  // An unavailable combination jumps to the first available variant with the value just picked.
  function sync(pop) {
    const json = pop.querySelector('[data-quick-variants]');
    if (!json) return;
    const variants = JSON.parse(json.textContent);
    const groups = Array.prototype.slice.call(pop.querySelectorAll('[data-quick-option]'));
    const picked = groups.map(function (g) { const c = g.querySelector('input:checked'); return c ? c.value : null; });
    let locked = false;
    groups.forEach(function (g, i) {
      Array.prototype.forEach.call(g.querySelectorAll('input'), function (r) {
        const ok = !locked && variants.some(function (v) {
          return v.available && v.options[i] === r.value &&
            picked.slice(0, i).every(function (val, j) { return val == null || v.options[j] === val; });
        });
        const lab = r.closest('.option');
        lab.hidden = !locked && !variants.some(function (v) {
          return v.options[i] === r.value && picked.slice(0, i).every(function (val, j) { return val == null || v.options[j] === val; });
        });
        lab.classList.toggle('is-locked', locked);
        lab.classList.toggle('is-unavailable', !locked && !ok);
        if (!ok && r.checked) { r.checked = false; picked[i] = null; }
      });
      const hint = g.parentElement.querySelector('[data-quick-hint]');
      if (hint) hint.hidden = !locked;
      if (picked[i] == null) locked = true;
    });
    const complete = picked.every(function (v) { return v != null; });
    const variant = complete ? variants.find(function (v) { return v.options.every(function (val, i) { return val === picked[i]; }); }) : null;
    const id = pop.querySelector('[data-quick-id]');
    const submit = pop.querySelector('[data-quick-submit]');
    if (id) id.value = variant ? variant.id : '';
    if (submit) {
      const ok = !!(variant && variant.available);
      submit.disabled = !ok;
      submit.innerHTML = ok
        ? submit.getAttribute('data-add-label') + ' &middot; <span data-quick-price>' + variant.price + '</span>'
        : (variant ? submit.getAttribute('data-sold-label') : submit.getAttribute('data-choose-label'));
    }
  }

  document.addEventListener('change', function (e) {
    const radio = e.target.closest('[data-quick-popover] [data-quick-option] input');
    if (!radio) return;
    sync(radio.closest('[data-quick-popover]'));
  });

  // Opening marks unavailable combinations; submitting closes the popover (the drawer takes over).
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-quick-pick]');
    if (!trigger) return;
    const scope = trigger.closest('.card') || trigger.parentElement;
    const pop = scope && scope.querySelector('[data-quick-popover]');
    if (pop && !pop.hidden) sync(pop);
  });
  document.addEventListener('submit', function (e) {
    if (e.target.closest('[data-quick-popover]')) setTimeout(function () { closeAll(null); }, 0);
  });
})();

/* ---------- Discount codes in the cart ---------- */
(function () {
  'use strict';
  // Mirrors the drawer refresh above (that one is private to its IIFE).
  async function refreshCartContents() {
    const current = document.querySelector('[data-cart-contents]');
    if (document.body.classList.contains('template-cart')) { location.reload(); return; }
    const res = await fetch(window.routes.cart_url + '?section_id=cart-drawer');
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const fresh = doc.querySelector('[data-cart-contents]');
    if (fresh && current) { current.innerHTML = fresh.innerHTML; window.MJ.initExpress(); }
    document.dispatchEvent(new CustomEvent('cart:contents'));
  }

  function appliedCodes() {
    return Array.from(document.querySelectorAll('[data-discount-code]'))
      .map(function (el) { return (el.getAttribute('data-discount-code') || '').trim(); })
      .filter(Boolean);
  }

  function showError(msg) {
    const el = document.querySelector('[data-discount-error]');
    if (!el) return;
    el.textContent = msg || '';
    el.hidden = !msg;
  }

  async function update(codes, check) {
    const res = await fetch(window.routes.cart_update_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    });
    if (!res.ok) throw new Error('discount update failed');
    const cart = await res.json();
    if (check) {
      const hit = (cart.discount_codes || []).find(function (d) {
        return (d.code || '').toLowerCase() === check.toLowerCase();
      });
      if (!hit || hit.applicable === false) throw new Error('not applicable');
    }
    return cart;
  }

  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('[data-discount-form]');
    if (!form) return;
    e.preventDefault();
    const input = form.querySelector('[name="discount"]');
    const button = form.querySelector('[type="submit"], button');
    const code = input ? input.value.trim() : '';
    if (!code) return;
    showError('');
    if (button) button.disabled = true;
    try {
      const codes = appliedCodes();
      if (codes.indexOf(code) === -1) codes.push(code);
      await update(codes, code);
      if (input) input.value = '';
      await refreshCartContents();
    } catch (err) {
      showError((window.themeStrings && window.themeStrings.discountError) || window.cartStrings.error);
      // Drop the rejected code again so the cart keeps only working ones.
      try { await update(appliedCodes().filter(function (c) { return c !== code; }), null); } catch (e2) {}
    } finally {
      if (button) button.disabled = false;
    }
  });

  document.addEventListener('click', async function (e) {
    const remove = e.target.closest('[data-discount-remove]');
    if (!remove) return;
    e.preventDefault();
    const chip = remove.closest('[data-discount-code]');
    const code = chip ? chip.getAttribute('data-discount-code') : null;
    if (!code) return;
    remove.disabled = true;
    showError('');
    try {
      await update(appliedCodes().filter(function (c) { return c !== code; }), null);
      await refreshCartContents();
    } catch (err) {
      showError((window.themeStrings && window.themeStrings.discountError) || window.cartStrings.error);
    } finally {
      remove.disabled = false;
    }
  });
})();

/* ---------- Predictive search ---------- */
(function () {
  'use strict';
  const input = document.querySelector('[data-search-input]');
  const out = document.querySelector('[data-predictive-results]');
  if (!input || !out || !window.routes || !window.routes.predictive_search_url) return;

  let timer;
  let controller;

  input.addEventListener('input', function () {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 2) { out.innerHTML = ''; return; }
    timer = setTimeout(async function () {
      if (controller) controller.abort();
      controller = new AbortController();
      const url = window.routes.predictive_search_url +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&section_id=predictive-search';
      try {
        const res = await fetch(url, { signal: controller.signal });
        if (!res.ok) throw new Error('predictive search failed');
        const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
        const section = doc.querySelector('.shopify-section') || doc.body;
        out.innerHTML = section.innerHTML;
      } catch (err) {
        if (err.name !== 'AbortError') out.innerHTML = '';
      }
    }, 200);
  });
})();

/* ---------- Search panel: focus the field on open ---------- */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-open="search"]')) return;
    const field = document.querySelector('[data-panel="search"] [data-search-input]');
    if (field) setTimeout(function () { field.focus(); field.select(); }, 80);
  });
})();

/* ---------- Mega menu: hover intent on desktop, tap below 1024px ----------
   JS owns .is-open. Leaving an item starts a short timer, so a diagonal move into the
   panel or a hop to the next item never closes it; a click on any link inside closes it
   until the mouse leaves (#type= navigation stays on the page). */
(function () {
  'use strict';
  const mq = window.matchMedia('(max-width: 1199px)');   // below this the nav is hidden (burger menu)
  const items = Array.prototype.slice.call(document.querySelectorAll('.hdr__item'));
  let closeTimer = null;
  let lastCloseAt = 0;

  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    if (!open) { item.classList.remove('is-switch'); lastCloseAt = Date.now(); }
    const toggle = item.querySelector('[data-mega-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
  }
  function closeAll(except) {
    items.forEach(function (item) { if (item !== except) setOpen(item, false); });
  }

  items.forEach(function (item) {
    item.addEventListener('mouseenter', function () {
      if (mq.matches || item.dataset.suppressed) return;
      clearTimeout(closeTimer);
      // coming from another category (or just after one closed): keep the panel, swap the content
      const switching = items.some(function (i) { return i !== item && i.classList.contains('is-open'); }) ||
        (Date.now() - lastCloseAt) < 400;
      closeAll(item);
      item.classList.toggle('is-switch', switching);
      setOpen(item, true);
    });
    item.addEventListener('mouseleave', function () {
      delete item.dataset.suppressed;
      if (mq.matches) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { setOpen(item, false); }, 300);
    });
    item.addEventListener('click', function (e) {
      if (mq.matches || !e.target.closest('a')) return;
      item.dataset.suppressed = '1';
      setOpen(item, false);
    });
    item.addEventListener('focusin', function () {
      if (mq.matches) return;
      closeAll(item);
      setOpen(item, true);
    });
    item.addEventListener('focusout', function (e) {
      if (!mq.matches && !item.contains(e.relatedTarget)) setOpen(item, false);
    });
  });

  document.addEventListener('click', function (e) {
    const toggle = e.target.closest('[data-mega-toggle]');
    const item = toggle && toggle.closest('.hdr__item');
    if (item) {
      if (!mq.matches) return;                 // desktop: the link navigates
      e.preventDefault();
      const open = item.classList.contains('is-open');
      closeAll(null);
      if (!open) setOpen(item, true);
      return;
    }
    if (!e.target.closest('.mega')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
})();

/* ---------- Header shadow after 24px ---------- */
(function () {
  'use strict';
  const hdr = document.querySelector('.hdr');
  if (!hdr) return;
  let queued = false;
  function apply() {
    queued = false;
    hdr.classList.toggle('is-scrolled', window.scrollY > 24);
  }
  window.addEventListener('scroll', function () {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(apply);
  }, { passive: true });
  apply();
})();

/* ---------- Old links /collections/all#type=X go to the category collection /collections/x ---------- */
(function () {
  'use strict';
  if (!/\/collections\/all\/?$/.test(window.location.pathname)) return;
  const raw = (window.location.hash || '').replace(/^#/, '');
  if (raw.indexOf('type=') !== 0) return;
  let type = decodeURIComponent(raw.slice(5)).replace(/\+/g, ' ').trim().toLowerCase().replace(/\s+/g, '-');
  if (type === 'shampoo' || type === 'conditioner') type = 'wassen'; // both live in one category collection
  if (type) window.location.replace(window.location.pathname.replace(/all\/?$/, '') + encodeURIComponent(type));
})();

/* ---------- PDP: "Je bespaart €x" next to the price ---------- */
(function () {
  'use strict';
  document.addEventListener('variant:change', function (e) {
    const el = document.querySelector('[data-product-save]');
    if (!el) return;
    const v = (e.detail || {}).variant;
    const onSale = v && v.compare_at_price && v.compare_at_price > v.price;
    if (!onSale) { el.hidden = true; el.textContent = ''; return; }
    const label = el.getAttribute('data-save-label') ||
      (window.themeStrings && window.themeStrings.save) || 'Je bespaart';
    el.textContent = label + ' ' + window.MJ.money(v.compare_at_price - v.price);
    el.hidden = false;
  });
})();

/* ---------- PDP: price in the buy button + selected option labels ---------- */
(function () {
  'use strict';
  document.addEventListener('variant:change', function (e) {
    const detail = e.detail || {};
    const variant = detail.variant;

    // "Geur: Kokos" labels above the option pills
    const values = (variant && variant.options) || detail.values || [];
    values.forEach(function (value, i) {
      const el = document.querySelector('[data-option-selected="' + (i + 1) + '"]');
      if (el && value != null) el.textContent = value;
    });

    if (!variant) return;
    const submit = document.querySelector('[type="submit"][data-add-label]');
    if (!submit) return;
    const label = variant.available
      ? submit.getAttribute('data-add-label') + ' · ' + window.MJ.money(variant.price)
      : (submit.getAttribute('data-sold-label') || submit.textContent);
    submit.textContent = label;

    // The sticky bar copied the old label (its listener runs first), so refresh it.
    const sticky = document.querySelector('[data-sticky-submit]');
    if (sticky) { sticky.textContent = label; sticky.disabled = !variant.available; }
  });
})();

/* ---------- PDP v2: quantity picker, price per 100 ml, volume option cards, sticky bar ---------- */
(function () {
  'use strict';
  // "250mL" / "1 L" / "1,5l" -> millilitres (0 when the value is not a volume).
  function ml(value) {
    const v = String(value || '').toLowerCase().replace(/\s+/g, '').replace(',', '.');
    const m = v.match(/^([\d.]+)(ml|l)$/);
    return m ? parseFloat(m[1]) * (m[2] === 'l' ? 1000 : 1) : 0;
  }
  function volumeOf(options) {
    for (const o of options || []) { const n = ml(o); if (n) return n; }
    return 0;
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    const input = btn.closest('[data-qty-pick]').querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(btn.getAttribute('data-qty-step')));
  });

  const jsonEl = document.querySelector('[data-variant-json]');
  const priceEl = document.querySelector('[data-product-price]');
  const promoPct = priceEl ? parseInt(priceEl.getAttribute('data-promo-pct') || '0', 10) : 0;
  const variants = JSON.parse((jsonEl && jsonEl.textContent) || '[]').map(function (v) {
    return Object.assign({}, v, { price: promoPct > 0 ? Math.round(v.price * (100 - promoPct) / 100) : v.price });
  });

  function update(v) {
    const money = window.MJ.money;
    const unitEl = document.querySelector('[data-unit-price]');
    const unitLabel = (unitEl && unitEl.getAttribute('data-unit-label')) || '%p / 100 ml';
    if (unitEl) {
      const n = v ? volumeOf(v.options) : 0;
      unitEl.hidden = !n;
      if (n) unitEl.textContent = unitLabel.replace('%p', money(Math.round(v.price * 100 / n)));
    }

    // Volume options as cards: price + price per 100 ml for the other current choices.
    let best = null;
    const cards = Array.prototype.slice.call(document.querySelectorAll('.option--card'));
    cards.forEach(function (card) {
      const pos = Number(card.getAttribute('data-position'));
      const val = card.getAttribute('data-value');
      const match = v && variants.find(function (x) {
        return x.options.every(function (o, i) { return i === pos - 1 ? o === val : o === v.options[i]; });
      });
      const n = ml(val);
      const priceSpan = card.querySelector('[data-opt-price]');
      const unitSpan = card.querySelector('[data-opt-unit]');
      priceSpan.textContent = match ? money(match.price) : '';
      unitSpan.textContent = match && n ? unitLabel.replace('%p', money(Math.round(match.price * 100 / n))) : '';
      card._perMl = match && n && !card.hidden ? match.price / n : null;
      if (card._perMl != null && (best == null || card._perMl < best._perMl)) best = card;
    });
    const priced = cards.filter(function (c) { return c._perMl != null; }).length;
    cards.forEach(function (card) {
      const bestLabel = card.querySelector('[data-opt-best]');
      if (bestLabel) bestLabel.hidden = !(priced > 1 && card === best);
    });

    // Sticky bar: variant line, compare-at price, plain add label.
    const sv = document.querySelector('[data-sticky-variant]');
    if (sv && v) sv.textContent = fmtVol(v.options.join(' · '));
    const sc = document.querySelector('[data-sticky-compare]');
    if (sc) {
      const onSale = v && v.compare_at_price > v.price;
      sc.hidden = !onSale;
      sc.textContent = onSale ? money(v.compare_at_price) : '';
    }
    const sticky = document.querySelector('[data-sticky-submit]');
    const submit = document.querySelector('[type="submit"][data-add-label]');
    if (submit && v && v.available) submit.textContent = submit.getAttribute('data-add-label') + ' · ' + money(v.price);
    if (sticky && submit && v && v.available) sticky.textContent = submit.getAttribute('data-add-label');

    // "250mL" -> "250 ml", "1L" -> "1 L" in the option labels and volume cards.
    document.querySelectorAll('[data-option-selected], .option--card .option__top b').forEach(function (el) {
      el.textContent = fmtVol(el.textContent);
    });
  }
  function fmtVol(t) { return String(t).replace(/(\d)\s*mL\b/g, '$1 ml').replace(/(\d)\s*L\b/g, '$1 L'); }

  document.addEventListener('variant:change', function (e) {
    const v = (e.detail || {}).variant;
    update(v);
    // Shareable URL for the chosen variant (?variant=ID), without a new history entry.
    if (v && jsonEl) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState(window.history.state, '', url);
    }
  });
  // The selector already announced its first variant before this listener existed.
  const idInput = document.querySelector('[data-variant-id]');
  if (jsonEl && idInput) update(variants.find(function (x) { return String(x.id) === idInput.value; }) || null);
})();

/* ---------- Footer: cookie preferences link ---------- */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    const link = e.target.closest('[data-cookie-prefs], a[href="#cookievoorkeuren"]');
    if (!link) return;
    // Shopify's native cookie banner exposes this API.
    if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
      e.preventDefault();
      window.privacyBanner.showPreferences();
    }
  });
})();

/* ---------- USP bar: auto-advance on phones, stops for good once the visitor takes over ---------- */
(function () {
  'use strict';
  const bar = document.querySelector('.usp__in');
  if (!bar || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  let stopped = false;
  ['pointerdown', 'wheel', 'keydown'].forEach(function (type) {
    bar.addEventListener(type, function () { stopped = true; }, { passive: true });
  });
  setInterval(function () {
    if (stopped || document.hidden || bar.scrollWidth <= bar.clientWidth) return;
    const atEnd = bar.scrollLeft + bar.clientWidth >= bar.scrollWidth - 1;
    bar.scrollTo({ left: atEnd ? 0 : bar.scrollLeft + bar.clientWidth, behavior: 'smooth' });
  }, 3500);
})();

/* ---------- Legal pages: table of contents + scroll spy ---------- */
(function () {
  'use strict';
  const content = document.querySelector('.legal-page__content, .main-content .shopify-policy__body .rte');
  if (!content) return;
  const heads = Array.from(content.querySelectorAll('h2'));
  if (heads.length < 2) return;

  const label = (window.themeStrings && window.themeStrings.legalToc) || 'Inhoudsopgave';
  const toc = document.createElement('details');
  toc.className = 'legal-toc';
  toc.innerHTML = '<summary class="legal-toc__title"></summary><nav class="legal-toc__nav"><ul></ul></nav>';
  const summary = toc.querySelector('summary');
  summary.textContent = label;
  toc.querySelector('nav').setAttribute('aria-label', label);
  const list = toc.querySelector('ul');

  const links = heads.map(function (h) {
    if (!h.id) {
      const base = h.textContent.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'sectie';
      let id = base;
      for (let n = 2; document.getElementById(id); n++) id = base + '-' + n;
      h.id = id;
    }
    const li = document.createElement('li');
    const a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent.trim();
    li.appendChild(a);
    list.appendChild(li);
    return a;
  });
  (content.closest('.shopify-policy__body') || content).before(toc);

  // Open on desktop (and not collapsible there), collapsed on mobile.
  const mq = window.matchMedia('(min-width: 900px)');
  function sync() { toc.open = mq.matches; }
  sync();
  mq.addEventListener('change', sync);
  summary.addEventListener('click', function (e) { if (mq.matches) e.preventDefault(); });
  toc.addEventListener('click', function (e) {
    if (e.target.closest('a') && !mq.matches) toc.open = false;
  });

  function setActive(a) { links.forEach(function (l) { l.classList.toggle('is-active', l === a); }); }
  if (!('IntersectionObserver' in window)) return;
  // Active = last h2 above a line at 40% of the viewport. The zone runs from far above the
  // viewport down to that line, so any jump across it fires; each callback re-reads all positions.
  let initial = true;
  const io = new IntersectionObserver(function () {
    const line = window.innerHeight * 0.4;
    let current = null;
    heads.forEach(function (h, i) { if (h.getBoundingClientRect().top < line) current = links[i]; });
    if (initial) {
      initial = false;
      const i = heads.findIndex(function (h) { return '#' + h.id === window.location.hash; });
      if (i > -1) current = links[i];
    }
    setActive(current || links[0]);
  }, { rootMargin: '100000px 0px -60% 0px' });
  heads.forEach(function (h) { io.observe(h); });
})();

/* ---------- Account: address forms ---------- */
(function () {
  'use strict';
  // all_country_option_tags has no selected option; preselect the saved country.
  Array.prototype.forEach.call(document.querySelectorAll('select[data-default]'), function (s) {
    if (s.getAttribute('data-default')) s.value = s.getAttribute('data-default');
  });
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-confirm]');
    if (btn && !window.confirm(btn.getAttribute('data-confirm'))) e.preventDefault();
  });
})();

/* ---------- Product page: echte Shop Pay-, Apple Pay- en Google Pay-knoppen op één rij, alleen logo ----------
   Shopify zet op productpagina's één knop met tekst. We zetten die tekst uit (isCTA) en plaatsen de andere wallets ernaast.
   Apple Pay komt uit de winkelgegevens in de pagina, Google Pay alleen uit de winkelwagenknoppen: die config levert Shopify
   pas bij een gevulde wagen.
   ponytail: niet-gedocumenteerd gebruik van Shopify's webcomponenten; bij een fout blijft de gewone knop staan. */
(function () {
  'use strict';
  const box = document.querySelector('.pdp-express');
  const base = box && box.querySelector('shopify-accelerated-checkout');
  if (!base || !window.customElements) return;

  const cartConfigs = function () {
    const tpl = box.querySelector('template[data-wallet-configs]');
    const source = tpl && tpl.content.querySelector('shopify-accelerated-checkout-cart');
    return source ? JSON.parse(source.getAttribute('wallet-configs')) : [];
  };
  const applePayConfig = function () {
    const el = document.getElementById('apple-pay-shop-capabilities');
    if (!el || !window.ApplePaySession || !window.ApplePaySession.canMakePayments()) return null;
    const cap = JSON.parse(el.textContent);
    const fields = cap.requiredShippingContactFields || [];
    return {
      supports_subs: true,
      supports_def_opts: false,
      name: 'apple_pay',
      wallet_params: {
        shopId: cap.shopId,
        countryCode: cap.countryCode,
        merchantCapabilities: cap.merchantCapabilities,
        merchantId: cap.merchantId,
        merchantName: cap.merchantName,
        customerAccountEmail: null,
        phoneRequired: fields.indexOf('phone') > -1,
        companyRequired: false,
        emailRequired: fields.indexOf('email') > -1,
        shippingType: cap.shippingType,
        supportedNetworks: cap.supportedNetworks,
        shopifyPaymentsEnabled: cap.shopifyPaymentsEnabled,
        supportsSubscriptions: cap.supportsSubscriptions
      }
    };
  };
  const logoOnly = function (Wallet) {
    let proto = Wallet.prototype;
    while (proto && !Object.getOwnPropertyDescriptor(proto, 'isCTA')) proto = Object.getPrototypeOf(proto);
    if (proto) Object.defineProperty(proto, 'isCTA', { configurable: true, get: function () { return false; } });
    return !!proto;
  };
  const copy = function (recommended) {
    const el = document.createElement('shopify-accelerated-checkout');
    Array.prototype.forEach.call(base.attributes, function (a) { el.setAttribute(a.name, a.value); });
    if (recommended) el.setAttribute('recommended', JSON.stringify(recommended));
    return el;
  };

  // page-type bepaalt alleen de stijl: op 'product' houdt Shopify 150px minimaal aan, waardoor drie knoppen niet passen.
  const compact = function () {
    box.querySelectorAll('[slot="button"]:not([page-type="cart_page"])').forEach(function (el) { el.setAttribute('page-type', 'cart_page'); });
  };

  customElements.whenDefined('shop-pay-wallet-button').then(function (Wallet) {
    if (!logoOnly(Wallet)) return;
    new MutationObserver(compact).observe(box, { childList: true, subtree: true });
    const current = JSON.parse(base.getAttribute('recommended') || '{}').name;
    const extra = cartConfigs();
    const apple = applePayConfig();
    if (apple && !extra.some(function (c) { return c.name === 'apple_pay'; })) extra.push(apple);
    base.replaceWith(copy());
    ['apple_pay', 'google_pay'].forEach(function (name) {
      const config = extra.filter(function (c) { return c.name === name; })[0];
      if (!config || name === current) return;
      const wrap = document.createElement('div');
      wrap.className = 'shopify-payment-button';
      wrap.appendChild(copy(config));
      box.appendChild(wrap);
    });
  }).catch(function () { /* gewone knop blijft staan */ });
})();
